import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";
import LoadingContent from "../../../components/LoadingContent";

const ScriptCameraRace = () => {
  const { access } = useIsAdmin();
  document.title = "LVF1 - Script Camera Change";
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const refPicture = useRef<any>(null);
  const [id, setId] = useState("");
  const [races, setRaces] = useState<{ name: string; id: number }[]>();
  const [validated, setValidated] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [show, setShow] = useState(false);
  const [driverNames, setdDriverNames] = useState<any>();
  const [missing, setMissing] = useState<ImportantEvent[]>();
  const [script, setScript] = useState("");

  const colors: string[] = [
    "#e6194b",
    "#3cb44b",
    "#ffe119",
    "#4363d8",
    "#f58231",
    "#911eb4",
    "#46f0f0",
    "#f032e6",
    "#bcf60c",
    "#fabebe",
    "#008080",
    "#e6beff",
    "#9a6324",
    "#fffac8",
    "#800000",
    "#aaffc3",
    "#808000",
    "#ffd8b1",
    "#000075",
    "#808080",
    "#ffffff",
    "#000000",
    "#ff69b4",
    "#a52a2a",
    "#5f9ea0",
    "#7fff00",
    "#d2691e",
    "#ff7f50",
    "#6495ed",
    "#dc143c",
    "#00ffff",
    "#00008b",
    "#008b8b",
    "#b8860b",
    "#a9a9a9",
    "#006400",
    "#bdb76b",
    "#8b008b",
    "#556b2f",
    "#ff8c00",
  ];

  type SessionFrame = number[];
  type DriverFrame = any[];
  type DriversData = Record<string, DriverFrame[]>;
  type CameraType = "ONBOARD" | "AERO";

  type CameraLog = {
    time: number;
    lap: number | string;
    driver: string;
    discard?: boolean;
    overtake?: boolean;
    overtakeMoment?: boolean;
    finished?: number;
    finishedInit?: number;
    overtakes: any[];
    finishes: any[];
    crashes: any[];
    pits: any[];
    extra: string;
    camera: CameraType;
  };

  interface ImportantEvent {
    type: "overtake" | "crash" | "finish" | "pit";
    time: number;
    position: number;
    piloto: string;
    priority: number;
    window: [number, number];
    val: any[];
  }

  const PRIORITY: Record<string, number> = {
    finish1: 1,
    dnf: 2,
    overtake: 3,
    crash: 4,
    finish: 5,
    pit: 6,
  };
  const [timeline, setTimeline] = useState<CameraLog[]>([]);

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/grandprix/getRaces`,
      )
      .then(({ data }) => {
        setRaces(data);
      })
      .catch(({ response }) => {
        throw new Error(response);
      });
  }, []);

  const generate = () => {
    fetch(`/assets/RaceRecords/${id}.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error al cargar el archivo");
        }
        return response.json();
      })
      .then((data) => {
        let finishGapNext: any = [];
        const sessionFrames = data.session;
        const driversHistory: Record<string, DriverFrame[]> = data.drivers;
        var driverNames = Object.keys(driversHistory);
        setdDriverNames(driverNames);
        let block = true;
        let countBlock = 0;
        let lapLeader = -1;
        let leader = "";
        let countOvertake = 0;
        let iniSecond = 0;
        let sec = "";
        let timelineResult: CameraLog[] = [];
        let finished: number[] = [];
        let selectedDriver = "";
        let inPits: { driver: string; time: number }[] = [];
        let extra = "";
        let postAccidents: any = {};
        let leaderFinished = false;
        let poleman = null;
        for (
          let frameIndex = 0;
          frameIndex < sessionFrames.length;
          frameIndex++
        ) {
          let overtakes = [];
          let finishes: any[] = [];
          let crashes: any[] = [];
          let pits: any[] = [];
          //let doBreak = false;
          for (const name of driverNames) {
            const frame = driversHistory[name][7][frameIndex];
            if (frame != null) {
              if (frameIndex > 0) {
                const lastframe = driversHistory[name][7][frameIndex - 1];
                if (frame[2] < lastframe[2]) {
                  for (const name2 of driverNames) {
                    const lastframe2 = driversHistory[name2][7][frameIndex - 1];
                    if (lastframe2[2] == frame[2]) {
                      //The driver had my current position => check if PIT, DNF..
                      const frame2 = driversHistory[name2][7][frameIndex];
                      if (
                        frame2[16] == 0 ||
                        (frame2[16] == 4 && frame[16] == 4) // both in PIT
                      ) {
                        overtakes.push([name, frame[2], lastframe[2], name2]);
                        countOvertake++;
                      }
                    }
                  }
                }
              }
              const pos = frame[2];
              const lap = frame[3];
              if (poleman == null && pos == 1) poleman = selectedDriver;
              if (pos == 2) sec = name;
              if (pos == 1 && countOvertake > 0 && block) countBlock++;
              if (block && countBlock == 50) {
                block = false;
                iniSecond = frameIndex;
              }
              if (block && pos == 1) {
                selectedDriver = name;
                timelineResult[frameIndex] = {
                  lap: countOvertake == 0 ? "" : lap,
                  time: frameIndex,
                  driver: selectedDriver,
                  overtakes,
                  extra,
                  finishes,
                  pits,
                  crashes,
                  camera: "AERO",
                };
              } else {
                extra = "";
                let closestDriver = "";
                let closestGap = Infinity;
                let bestPos = Infinity;
                for (const name of driverNames) {
                  const frame = driversHistory[name][7][frameIndex];
                  if (frame != null) {
                    let pos = parseInt(frame[2]);
                    const lap = frame[3];
                    const rawGap = frame[8];
                    const rawGapLeader = frame[7];
                    const status = frame[16];
                    const gapStr = rawGap?.split("+ ")[1];
                    let gap = convertirATiempoEnSegundos(gapStr);
                    const gapStrLeader = rawGapLeader?.split("+ ")[1];
                    let gapLeader = convertirATiempoEnSegundos(gapStrLeader);
                    if (pos == 1) {
                      lapLeader = lap;
                      leader = name;
                    }

                    /*** CASE FINISHED ***/
                    if (status == 1 && finishGapNext["P" + pos] == null) {
                      for (const name_ of driverNames) {
                        const frame_aux = driversHistory[name_][7][frameIndex];
                        const pos_aux = parseInt(frame_aux[2]);
                        if (pos_aux == pos + 1) {
                          const gapStr = frame_aux[8]?.split("+ ")[1];
                          const gap = convertirATiempoEnSegundos(gapStr);
                          finishGapNext["P" + pos] = gap;
                        }
                      }
                    }

                    if (status == 1 && pos < 4 && !finished.includes(pos)) {
                      leaderFinished = true;
                      finished.push(pos);
                      finishes.push([name, pos]);
                    }
                    //PARTE NUEVA PARA VER FINALIZADOS CON GAP CERCANO!! NO SE PROBÓ BIEN
                    else if (
                      status == 1 &&
                      pos >= 4 &&
                      finishGapNext["P" + pos] < 1 &&
                      !finished.includes(pos)
                    ) {
                      finished.push(pos);

                      finishes.push([name, pos]);
                    }
                    /*** CASE PIT ***/
                    const driver = inPits.find(
                      (driver) => driver.driver == name,
                    );
                    if (status == 4 && pos < 4) {
                      if (driver == null) {
                        pits.push([name, pos, "IN"]);
                        inPits.push({ driver: name, time: 1 });
                      }
                    } else if (
                      pos < 6 &&
                      status == 0 &&
                      frameIndex > 5 &&
                      driver?.driver == name
                    ) {
                      //Buscamos gap con el de atras
                      let isCloseGap = false;
                      if (gap < 4.5) isCloseGap = true;
                      else {
                        for (const name_ of driverNames) {
                          const frame_ = driversHistory[name_][7][frameIndex];
                          let pos = parseInt(frame_[2]);
                          const rawGap_ = frame_[8];
                          const gapStr_ = rawGap_?.split("+ ")[1];
                          let gap_ = convertirATiempoEnSegundos(gapStr_);
                          if (pos === pos + 1 && gap_ < 4.5) {
                            isCloseGap = true;
                            break;
                          }
                        }
                      }
                      pits.push([name, pos, "OUT", isCloseGap]);
                      inPits = inPits.filter(
                        (driver) => driver.driver !== name,
                      );
                    }

                    if (isNaN(gap)) continue;
                    // Verificamos que el piloto no esté en primera posición y esté cerca del de delante
                    if (pos > 1 && gap < 1.2 && status == 0) {
                      // Preferimos primero menor posición, luego menor gap
                      if (
                        pos < bestPos ||
                        (pos === bestPos && gap < closestGap)
                      ) {
                        closestDriver = name;
                        closestGap = gap;
                        bestPos = pos;
                      }
                    }
                    if (
                      status === 1 &&
                      (name == closestDriver || name == selectedDriver)
                    ) {
                      closestDriver = leader;
                      selectedDriver = leader;
                    }

                    /*** CASE INCIDENT ***/
                    if (frameIndex > 3 && status == 0) {
                      const prev5Frame =
                        driversHistory[name][7][frameIndex - 4];
                      const prev10Frame =
                        driversHistory[name][7][frameIndex - 10];
                      const rawGap2 = prev5Frame[8];
                      const gapStr2 = rawGap2?.split("+ ")[1];
                      const rawGap2Leader = prev5Frame[7];
                      const gapStr2Leader = rawGap2Leader?.split("+ ")[1];
                      let gap2 = convertirATiempoEnSegundos(gapStr2);
                      let pos2 = parseInt(prev5Frame[2]);
                      let gapLeader2 =
                        convertirATiempoEnSegundos(gapStr2Leader);
                      //CASE LEADER INCIDENT!! NEED TO CHECK 2ND DRIVER INSTEAD THE PREVIOUS
                      if (pos === 1) {
                        for (const name_ of driverNames) {
                          const frame_ = driversHistory[name_][7][frameIndex];
                          const pos_ = parseInt(frame_[2]);
                          if (pos_ === 2) {
                            const rawGap_ = frame_[8];
                            const gapStr_ = rawGap_?.split("+ ")[1];
                            let gap2_ = convertirATiempoEnSegundos(gapStr_);

                            const prev5Frame_ =
                              driversHistory[name_][7][frameIndex - 4];
                            const rawGap2_ = prev5Frame_[8];
                            const gapStr2_ = rawGap2_?.split("+ ")[1];
                            let gap_ = convertirATiempoEnSegundos(gapStr2_);

                            if (
                              gap2_ != Infinity &&
                              gap_ != Infinity &&
                              gap_ - gap2_ > 3
                            ) {
                              gap = gap_;
                              gap2 = gap2_;
                              gapLeader = 0;
                              gapLeader2 = 0;
                              pos2 = 1;
                              pos = 1;
                            }
                          }
                        }
                      }
                      //CASO DE INDEX 1950 EN SILVERSTONE 2025. PONIA MUCHOS ACCIDENTES CUANDO FENO PASABA A IMLUKER QUE ESTABA EN BOX.
                      //PARECE QUE EL GAP BAJABA Y LUEGO AUMENTABA REPENTINAMENTE EN EL ADELANTAMIENTO. MIRAMOS SI HACE 5S EL LIDER NO IBA LIDER.
                      let sorpassoLeader = false;
                      if (gapLeader - gapLeader2 > 3.3) {
                        for (const name_ of driverNames) {
                          const frame_ = driversHistory[name_][7][frameIndex];
                          const frame5_ =
                            driversHistory[name_][7][frameIndex - 5];
                          const pos_ = parseInt(frame_[2]);
                          const pos5_ = parseInt(frame5_[2]);
                          if (pos_ === 1 && pos5_ > 1) sorpassoLeader = true;
                        }
                      }
                      if (
                        gap2 != Infinity &&
                        gap != Infinity &&
                        gapLeader != Infinity &&
                        gapLeader2 != Infinity &&
                        ((gap - gap2 > 3 && pos == pos2) ||
                          (!leaderFinished &&
                            gapLeader - gapLeader2 > 3.3 &&
                            !sorpassoLeader)) &&
                        frameIndex > 90 &&
                        !hasPreviouslyAccident(
                          timelineResult,
                          frameIndex,
                          name,
                        ) &&
                        prev10Frame[16] !== 4 &&
                        status === 0
                      ) {
                        const exists = crashes.some(
                          (overtake) =>
                            overtake[0] === name && overtake[1] === pos,
                        );
                        if (!exists) {
                          crashes.push([name, pos]);
                        }
                      }
                    }

                    /*** CASE OUT ***/
                    if (frameIndex > 3 && (status == 2 || status == 3)) {
                      const prev1Frame =
                        driversHistory[name][7][frameIndex - 1];
                      if (prev1Frame[16] == 0) {
                        //closestDriver = name;
                        //extra = "OUT " + name;
                        const exists = crashes.some(
                          (overtake) =>
                            overtake[0] === name && overtake[1] === pos,
                        );
                        if (!exists) crashes.push([name, pos, "OUT"]);
                      }
                    }
                  }
                }
                //if (doBreak) break; //+x lap, IN PIT..
                if (timelineResult[frameIndex] == null) {
                  if (closestDriver !== "") {
                    selectedDriver = closestDriver;
                    timelineResult[frameIndex] = {
                      lap: countOvertake == 0 ? "" : lapLeader,
                      time: frameIndex,
                      driver: selectedDriver,
                      overtakes: overtakes,
                      finishes,
                      crashes,
                      pits,
                      extra,
                      camera: "AERO",
                    };
                  } else {
                    timelineResult[frameIndex] = {
                      lap: countOvertake == 0 ? "" : lapLeader,
                      time: frameIndex,
                      driver: selectedDriver,
                      discard: true,
                      overtakes: overtakes,
                      finishes,
                      crashes,
                      pits,
                      extra,
                      camera: "AERO",
                    };
                  }
                }
              }
            }
          }
        }

        cleanRepeatedCrashes(timelineResult, driversHistory); // modifica timeline in-place
        const events = extractImportantEvents(
          timelineResult,
          iniSecond,
          driversHistory,
        );
        const filteredEvents = resolveOverlaps(
          events.events,
          events.missing,
          iniSecond,
        );
        let timeline = assignPilotsToSeconds(
          timelineResult,
          filteredEvents,
          iniSecond + 80,
        );
        timeline = removeShortDriverSegments(timeline);
        setTimeline(timeline);
      })
      .catch((error) => {
        console.error("Error al leer el archivo JSON:", error);
      });
  };

  const hasPreviouslyAccident = (
    timelineResult: any,
    frameIndex: number,
    name: string,
  ) => {
    for (var i = frameIndex - 90; i < frameIndex; i++) {
      if (timelineResult[i].extra == "ACCIDENT PREV " + name) return true;
    }
    return false;
  };

  function convertirATiempoEnSegundos(tiempo: string | undefined): number {
    if (!tiempo || typeof tiempo !== "string") return Infinity;

    // Caso: solo segundos con decimales, como "4.770"
    if (/^\d+(\.\d+)?$/.test(tiempo.trim())) {
      return parseFloat(tiempo);
    }

    // Caso: minutos:segundos.milisegundos, como "1:21.222"
    if (/^\d+:\d{1,2}(\.\d+)?$/.test(tiempo.trim())) {
      const [minStr, rest] = tiempo.split(":");
      const [segStr, milStr = "0"] = rest.split(".");

      const minutos = parseInt(minStr, 10);
      const segundos = parseInt(segStr, 10);
      const milisegundos = milStr.padEnd(3, "0").slice(0, 3); // asegura 3 dígitos

      const totalSegundos = minutos * 60 + segundos;
      return parseFloat(`${totalSegundos}.${milisegundos}`);
    }

    // Formato no reconocido
    return Infinity;
  }

  const extra = (event: ImportantEvent) => {
    if (event.type == "overtake")
      return (
        <label key={`overtake-T${event.time}`}>
          🏎️ {event.val[0]} → P{event.val[1]} - P{event.val[2]} ({event.val[3]})
        </label>
      );
    else if (event.type == "crash")
      return (
        <label key={`crash-T${event.time}`}>
          ❌ [CRASH] {event.val[0]} {event.val[1]}º{" "}
          {event.val[2] != null && "💀 DNF"}
        </label>
      );
    else if (event.type == "pit")
      return (
        <label key={`pits-T${event.time}`}>
          🛠️ [PIT] {event.val[0]} {event.val[1]}º ({event.val[2]})
        </label>
      );
    else if (event.type == "finish")
      return (
        <label key={`finishes-T${event.time}`}>
          🏁 [FINISH] {event.val[0]} {event.val[1]}º
        </label>
      );
    return <></>;
  };

  const extra2 = (timeline: CameraLog) => {
    const overtakes = timeline.overtakes.map((overtake, index) => (
      <p key={`overtake-${index}`}>
        🏎️ {overtake[0]} → P{overtake[1]} - P{overtake[2]} ({overtake[3]})
        {/*overtake[4] != null ? " [not recorded]" : ""*/}
      </p>
    ));

    const crashes = timeline.crashes.map((crash, index) => (
      <p key={`crash-${index}`}>
        ❌ [CRASH] {crash[0]} {crash[1]}º {crash[2] != null && "💀 DNF"}
      </p>
    ));

    const finishes = timeline.finishes.map((crash, index) => (
      <p key={`finishes-${index}`}>
        🏁 [FINISH] {crash[0]} {crash[1]}º
      </p>
    ));

    const pits = timeline.pits.map((crash, index) => (
      <p key={`pits-${index}`}>
        🛠️ [PIT] {crash[0]} {crash[1]}º ({crash[2]})
      </p>
    ));
    return [...overtakes, ...crashes, ...finishes, ...pits];
  };

  function isDarkColor(hex: string): boolean {
    // Elimina el #
    const color = hex.replace("#", "");

    // Convierte en valores RGB
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);

    // Calcula luminancia percibida
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

    // Umbral: <128 se considera oscuro
    return luminance < 128;
  }

  function extractImportantEvents(
    raceData: CameraLog[],
    iniSecond: number,
    driversHistory: Record<string, DriverFrame[]>,
  ): { events: ImportantEvent[]; missing: ImportantEvent[] } {
    const events: ImportantEvent[] = [];
    const missing: ImportantEvent[] = [];
    for (let t = 0; t < raceData.length; t++) {
      if (t < iniSecond) continue;
      const second = raceData[t];

      const getMinPosEvent = (arr: [string, number, string?, boolean?][]) =>
        arr.reduce((min, curr) => (curr[1] < min[1] ? curr : min), arr[0]);

      if (second.finishes.length > 0) {
        const min = getMinPosEvent(second.finishes);
        const isWinner = min[1] === 1;
        events.push({
          type: "finish",
          time: t,
          position: min[1],
          piloto: min[0],
          priority: isWinner ? PRIORITY.finish1 : PRIORITY.finish,
          window: [t - 12, t + 12],
          val: min,
        });
        // Añadir los que no son el más destacado
        for (const f of second.finishes) {
          if (f !== min) {
            const isWinner = f[1] === 1;
            missing.push({
              type: "finish",
              time: t,
              position: f[1],
              piloto: f[0],
              priority: isWinner ? PRIORITY.finish1 : PRIORITY.finish,
              window: [t - 12, t + 12],
              val: f,
            });
          }
        }
      } else if (
        second.overtakes.length > 0 &&
        !(
          //Caso de que haya accidente + overtake sobre ese accidente: grabamos accidente, asique pasamos de entrar aqui
          (
            second.overtakes.length === 1 &&
            second.crashes.length === 1 &&
            second.overtakes[0][2] === second.crashes[0][1]
          )
        )
      ) {
        const min = getMinPosEvent(second.overtakes);
        events.push({
          type: "overtake",
          time: t,
          position: min[1],
          piloto: min[0],
          priority: PRIORITY.overtake,
          window: [t - 12, t + 12],
          val: min,
        });

        for (const o of second.overtakes) {
          if (o !== min) {
            missing.push({
              type: "overtake",
              time: t,
              position: o[1],
              piloto: o[0],
              priority: PRIORITY.overtake,
              window: [t - 12, t + 12],
              val: o,
            });
          }
        }
      } else if (second.crashes.length > 0) {
        const min = getMinPosEvent(second.crashes);
        const isDNF = min[2] != null;
        events.push({
          type: "crash",
          time: t,
          position: min[1],
          piloto: min[0],
          priority: isDNF || min[1] < 4 ? PRIORITY.dnf : PRIORITY.crash,
          window: [t - 12, isDNF ? t : t + 12],
          val: min,
        });

        for (const c of second.crashes) {
          if (c !== min) {
            const isDNF = c[2] != null;
            missing.push({
              type: "crash",
              time: t,
              position: c[1],
              piloto: c[0],
              priority: isDNF || c[1] < 4 ? PRIORITY.dnf : PRIORITY.crash,
              window: [t - 12, isDNF ? t : t + 12],
              val: c,
            });
          }
        }
      } else if (second.pits.length > 0) {
        const min = getMinPosEvent(second.pits);
        const outAux = min[3] ? 8 : 0;
        events.push({
          type: "pit",
          time: t,
          position: min[1],
          piloto: min[0],
          priority: PRIORITY.pit,
          window: [t - 4, t + 4 + outAux],
          val: min,
        });

        for (const p of second.pits) {
          if (p !== min) {
            const outAux = min[3] ? 8 : 0;
            missing.push({
              type: "pit",
              time: t,
              position: p[1],
              piloto: p[0],
              priority: PRIORITY.pit,
              window: [t - 4, t + 4 + outAux],
              val: p,
            });
          }
        }
      }

      if (second.crashes.length > 0) {
        const min = getMinPosEvent(second.crashes);
        const pos = min[1];
        const posLater = driversHistory[min[0]][7][t + 10]?.[2];
        if (posLater > pos) {
          const isDNF = min[2] != null;
          const crashEvent = events[events.length - 1];
          crashEvent.type = "crash";
          crashEvent.time = t;
          crashEvent.position = min[1];
          crashEvent.piloto = min[0];
          crashEvent.priority = PRIORITY.dnf;
          crashEvent.window = [t - 12, isDNF ? t : t + 12];
        }
      }
    }
    return { events, missing };
  }

  function resolveOverlaps(
    events: ImportantEvent[],
    missing: ImportantEvent[],
    iniSecond: number,
  ): ImportantEvent[] {
    const result: ImportantEvent[] = [];
    // Orden cronológico
    for (const current of events) {
      const minGapInit = current.type == "pit" ? 2 : 5;
      const fullGapInit = current.type == "pit" ? 4 : 12;

      if (result.length === 0) {
        if (current.time - fullGapInit < iniSecond) continue;
        result.push(current);
        continue;
      }
      const last = result[result.length - 1];
      const minGapLastInit = last.type == "pit" ? 2 : 5;
      const fullGapLastInit = last.type == "pit" ? 4 : 12;
      if (current.time - fullGapInit < iniSecond) continue;
      if (current.time - fullGapInit > last.time + fullGapLastInit) {
        result.push(current);
      } else if (current.time - minGapInit >= last.time + minGapLastInit) {
        const midpoint = Math.ceil((last.time + current.time) / 2);
        last.window[1] = midpoint - 1;
        current.window[0] = midpoint;
        result.push(current);
      } else {
        // Muy cercanos, se descarta el segundo, a no ser que sea mejor prioridad (MEJOR PRIORIDAD ES VALOR MAS BAJO!)
        if (
          //Caso de que haya un accidente de un piloto peor a otro que adelantó.
          //En ese caso damos preferencia al adelantamiento! Caso de 1044 de Silverstone, que antes pasaba a Adam y cortaba el adelantamiento de Proebaka
          current.priority > 1 &&
          current.priority < 4 &&
          last.priority > current.priority &&
          current.position > last.position
        ) {
          last.priority = 2;
          current.priority = 3;
        }
        if (current.priority < last.priority) {
          // Cortar el anterior justo antes del nuevo
          const newStart = current.time - 2;
          if (newStart > last.window[0]) {
            last.window[1] = newStart - 1;
          } else {
            // Si no queda ventana útil para el anterior, lo quitamos
            result.pop();
          }
          // Ajustar ventana del nuevo evento
          const duration = current.window[1] - current.window[0];
          current.window[0] = newStart;
          current.window[1] = newStart + duration;
          result.push(current);
        } else {
          if (current.type == "finish" && current.position < 4) {
            last.window[1] = current.time - 1;
            current.window[0] = current.time;
            current.window[1] = current.time + 5;
            result.push(current);
          } else if (
            current.type == "overtake" &&
            current.time - last.time <= 5
          ) {
            if (last.val.includes(current.piloto)) {
              //casos de intercambios de posicion muy seguidos. Proebaka Silverstone 2025 en 1044.
              result.push(current);
            } else if (current.position < last.position) {
              missing.push(last);
              last.piloto = current.piloto;
              last.position = current.position;
              last.time = current.time;
              last.val = current.val;
              last.window = current.window;
            }
          } else {
            missing.push(current);
          }
        }
        continue;
      }
    }
    setMissing(missing);
    return result;
  }

  function assignPilotsToSeconds(
    raceData: CameraLog[],
    events: ImportantEvent[],
    initSecond: number,
  ): CameraLog[] {
    let lastPilot = raceData[0]?.driver ?? "";
    let lastCamera: CameraType = "ONBOARD";

    for (let t = 0; t < raceData.length; t++) {
      if (t < initSecond) {
        // Antes del segundo 500 siempre AERO
        raceData[t].camera = "AERO";

        // Para piloto, igual que antes buscamos evento activo
        const activeEvent = events.find(
          (e) => t >= e.window[0] && t <= e.window[1],
        );
        if (activeEvent) {
          raceData[t].driver = activeEvent.piloto;
          lastPilot = activeEvent.piloto;
        } else {
          //raceData[t].driver = lastPilot;
          //comentado porque cuando el lider perdia posicion al principio no actualizaba al nuevo lider
        }

        // Seguir al siguiente segundo
        continue;
      }
      // Buscamos evento activo para este segundo
      const activeEvent = events.find(
        (e) => t >= e.window[0] && t <= e.window[1],
      );

      if (activeEvent) {
        // Asignar piloto siempre si hay evento activo
        // La descomenté creo que para cuando el lider llegaba a meta, pero me cargaba muchos cambios de posicion que no se grababan.
        // Por ejemplo Proebaka adelantamiento en el 972 de Silverstone 2025
        // así que de momento la dejo de nuevo
        raceData[t].driver = activeEvent.piloto;

        // Lógica cámara según tipo evento
        switch (activeEvent.type) {
          case "pit":
            raceData[t].camera = "AERO";
            lastCamera = "AERO";
            break;

          case "crash":
            if (t < activeEvent.time) {
              raceData[t].camera = "AERO";
              lastCamera = "AERO";
            } else {
              // En el segundo exacto del crash o después, ONBOARD
              raceData[t].camera = "ONBOARD";
              lastCamera = "ONBOARD";
            }
            break;

          case "finish":
            raceData[t].camera = "AERO";
            lastCamera = "AERO";
            break;

          case "overtake":
            // Desde 2 segundos antes hasta el evento, AERO
            if (t >= activeEvent.time - 2) {
              raceData[t].camera = "AERO";
              lastCamera = "AERO";
            } else {
              // Antes, ONBOARD
              raceData[t].camera = "ONBOARD";
              lastCamera = "ONBOARD";
            }
            break;

          default:
            // Por defecto ONBOARD
            raceData[t].camera = "AERO";
            lastCamera = "AERO";
        }

        lastPilot = activeEvent.piloto;
      } else {
        // No hay evento activo, mantenemos últimos valores
        /*raceData[t].driver = lastPilot;
        raceData[t].camera = lastCamera;*/
      }
    }

    return raceData;
  }

  function cleanRepeatedCrashes(
    timeline: {
      crashes: [string, number, string?][];
    }[],
    driversHistory: Record<string, DriverFrame[]>,
  ): void {
    const lastCrashSecond: Record<string, number> = {};

    for (let second = 0; second < timeline.length; second++) {
      const currentCrashes = timeline[second].crashes;

      timeline[second].crashes = currentCrashes.filter((crash) => {
        const [pilot, , flag] = crash;

        // Si ha crasheado recientemente (por ejemplo, en los últimos 5 segundos), descartar
        const lastSecond = lastCrashSecond[pilot];
        if (
          lastSecond !== undefined &&
          second - lastSecond <= 60 &&
          flag == null
        ) {
          return false;
        }

        // Si entra a boxes 10 segundos después del crash, se descarta
        if (driversHistory[pilot]?.[7]?.[second + 10]?.[16] === 4) {
          return false;
        }

        // Guardar el último segundo donde fue considerado crash
        lastCrashSecond[pilot] = second;
        return true;
      });
    }
  }
  function removeShortDriverSegments(logs: CameraLog[]): CameraLog[] {
    if (logs.length === 0) return logs;

    const result: CameraLog[] = [...logs];
    let i = 0;

    while (i < result.length) {
      const currentDriver = result[i].driver;
      let j = i;

      // Busca cuánto dura el mismo piloto seguido
      while (j < result.length && result[j].driver === currentDriver) {
        j++;
      }

      const duration = j - i;
      if (duration <= 3) {
        const replacementDriver =
          i > 0 ? result[i - 1].driver : result[j]?.driver;
        if (replacementDriver) {
          // Reemplaza el piloto en el rango i..j-1
          for (let k = i; k < j; k++) {
            result[k] = { ...result[k], driver: replacementDriver };
          }
        }
      }

      i = j; // Avanza al siguiente bloque
    }

    return result;
  }
  useEffect(() => {
    const trimmedTimeline = timeline.slice(
      timeline.findIndex(
        (entry) => entry.overtakes && entry.overtakes.length > 0,
      ),
    );
    setScript(`
      (function() {
        const timeline = ${JSON.stringify(trimmedTimeline)};
        let index = 0;
        let lastDriver = null;
        let lastCamera = null;

        function findDriverIndex(driverName) {
          const elements = document.getElementsByClassName("driver-column");
          for (let i = 0; i < elements.length; i++) {
            const span = elements[i].getElementsByTagName("span")[0];
            if (span && span.textContent.trim() === driverName) {
              return i;
            }
          }
          return -1;
        }

        function step() {
          if (index >= timeline.length) {
            clearInterval(interval);
            return;
          }

          const log = timeline[index];
          const currentDriver = log.driver;
          console.log(log.time, currentDriver);

          if (currentDriver !== lastDriver || log.camera !== lastCamera) {
            const idx = findDriverIndex(currentDriver);
            if (idx !== -1) {
              const driverCell = document.getElementsByClassName("driver-column")[idx];
              const row = driverCell?.parentElement; // <tr>
              const td5 = row?.children[5]; // <td> con los botones

              if (td5) {
                const buttons = td5.getElementsByTagName("button");
                if (log.camera === "ONBOARD") {
                  buttons[1]?.click(); // segundo botón
                } else {
                  buttons[0]?.click(); // primer botón
                }
              }
            }
            lastDriver = currentDriver;
            lastCamera = log.camera;
          }

          index++;
        }

        const interval = setInterval(step, 1000);
      })();
    `);
  }, [timeline]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(script);
      toast("Script copied");
    } catch {}
  };

  const convertToCurrentTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    const pad = (n: number) => n.toString().padStart(2, "0");

    if (h > 0) {
      return `${h}:${pad(m)}:${pad(s)}`;
    } else {
      return `${m}:${pad(s)}`;
    }
  };
  if (!access) return <ErrorPage />;
  if (races == null) return <LoadingContent />;
  return (
    <div className="full-height padding-xl app-container flex-center-top page-transition">
      <div className="form-container">
        <Title text="Script Camera Change" />
        <small className="mandatory-fields">(*) Required fields</small>
        <Form noValidate validated={validated}>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Race (*)</Form.Label>
              <Form.Select
                name="id"
                required
                value={id}
                onChange={(e) => {
                  setId(e.target.value);
                }}
              >
                <option>None</option>
                {races.map((race) => {
                  return (
                    <option key={race.id} value={race.id}>
                      {race.name}
                    </option>
                  );
                })}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-center">
            {uploading ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
            ) : (
              <Button variant="primary" onClick={generate}>
                Generate
              </Button>
            )}
          </div>
        </Form>
        {timeline.length > 0 && (
          <div className="relative">
            <h2>
              📹 Camera Chronology
              <span
                className="profile-bubble"
                data-tooltip="Open Replay in-Game and paste script into http://localhost:5397/overlays/controlpanel.html just when green flag appears"
                data-flow="right"
              >
                <FontAwesomeIcon
                  icon={faQuestionCircle}
                  className="label-icon"
                />
              </span>
            </h2>
            <button
              id="copyScript"
              className="btn btn-secondary"
              onClick={handleCopy}
            >
              Copy
            </button>
            <pre id="pre-script">{script}</pre>

            <h2>🚫 Missing moments</h2>
            <table id="table-missing">
              <thead>
                <tr>
                  <th>Lap</th>
                  <th>Time</th>
                  <th>Driver</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {missing
                  ?.sort((a, b) => a.time - b.time)
                  ?.map((moment) => {
                    return (
                      <tr>
                        <td>{timeline[moment.time].lap}</td>
                        <td>
                          {convertToCurrentTime(moment.time)} ({moment.time})
                        </td>
                        <td>{moment.piloto}</td>
                        <td>{extra(moment)}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div id="cronology-button">
              <button
                className="btn btn-secondary"
                onClick={() => setShow(!show)}
              >
                {show ? "Hide Chronology" : "Show Chronology"}
              </button>
            </div>
            {show && (
              <table className="border w-full text-sm" id="camera-script">
                <thead>
                  <tr>
                    <th className="border px-2 py-1">Lap</th>
                    <th className="border px-2 py-1">Tiempo (s)</th>
                    <th className="border px-2 py-1">Piloto Enfocado</th>
                    <th className="border px-2 py-1">Extra</th>
                    <th className="border px-2 py-1">Overtakes</th>
                  </tr>
                </thead>
                <tbody>
                  {timeline.map((item, idx) => (
                    <tr
                      key={idx}
                      style={{
                        background: colors[driverNames.indexOf(item.driver)],
                        color: isDarkColor(
                          colors[driverNames.indexOf(item.driver)],
                        )
                          ? "#fff"
                          : "#000",
                      }}
                    >
                      <td className="border px-2 py-1">{item.lap}</td>
                      <td className="border px-2 py-1">{item.time}</td>
                      <td className="border px-2 py-1">{item.driver}</td>
                      <td className="border px-2 py-1">{item.camera}</td>
                      <td className="border px-2 py-1">{extra2(item)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ScriptCameraRace;
